// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150117/js/" + chunkId + "." + {"44":"dd283227","225":"b2ca53cb","481":"99645d2a","486":"f6758dbf","770":"c7093fb2"}[chunkId] + ".0.7782597163996993.chunk.js";
};